module.exports = __webpack_public_path__ + "img/IMG_0577_8_9_L.8746ba46.webp";